export class MeterStockItem {
  meterNumber: string = '';
  meterPhase: string = '';
  meterRating: string = '';
  serialNumber: string = '';
  meterMake: string = '';
  meterModel: string = '';
  meterType: string = '';
  dtMeterType: string = '';
  uploadDate?: string = '';
  dispatchDate?: Date;
  region: string = '';
  area: string = '';
  regionId: number | null = null;
  geographicalRegionId: number | null = null;
  geographicalRegionName: string = '';
  subGeographicalRegionName: string = '';
  installationDate?: string = '';
  uploadedBy: string = '';
  status: string = '';
  isChecked: boolean = false;
  lifespan: number = 0;
  age: number = 0;
  id: number = 0;
  organization: string = '';
  accountNumber: string = '';
  sealNumber: string = '';
  customerName: string = '';
  customerAddress: string = '';
  assetName: string = '';
  assetAddress: string = '';
  tagSerialNumber: string = '';
  instrumentSerialNumber: string = '';
  voltageLevel: string = '';

  constructor(data?: any) {
    this.meterNumber = data?.meterNumber ?? '';
    this.meterPhase = data?.meterPhase ?? '';
    this.meterRating = data?.meterRating ?? '';
    this.serialNumber = data?.serialNumber ?? '';
    this.meterMake = data?.meterMake ?? '';
    this.meterModel = data?.meterModel ?? '';
    this.meterType = data?.meterType ?? '';
    this.dtMeterType = data?.dtMeterType ?? '';
    this.uploadDate = data?.uploadDate ?? '';
    this.dispatchDate = data?.dispatchDate ?? null;
    this.region = data?.region ?? '';
    this.area = data?.area ?? '';
    this.regionId = data?.regionId ?? null;
    this.geographicalRegionId = data?.geographicalRegionId ?? null;
    this.geographicalRegionName = data?.geographicalRegionName ?? '';
    this.subGeographicalRegionName = data?.subGeographicalRegionName ?? '';
    this.installationDate = data?.installationDate ?? '';
    this.uploadedBy = data?.uploadedBy ?? '';
    this.status = data?.status ?? '';
    this.isChecked = data?.isChecked ?? false;
    this.lifespan = data?.lifespan ?? 0;
    this.age = data?.age ?? 0;
    this.id = data?.id ?? 0;
    this.organization = data?.organization ?? '';
    this.accountNumber = data?.accountNumber ?? '';
    this.sealNumber = data?.sealNumber ?? '';
    this.customerName = data?.customerName ?? '';
    this.customerAddress = data?.customerAddress ?? '';
    this.assetName = data?.assetName ?? '';
    this.assetAddress = data?.assetAddress ?? '';
    this.tagSerialNumber = data?.tagSerialNumber ?? '';
    this.instrumentSerialNumber = data?.instrumentSerialNumber ?? '';
    this.voltageLevel = data?.voltageLevel ?? '';
  }
}

export class MeterStockItemStats {
  total: number | undefined;
  singlePhase: number | undefined;
  threePhase: number | undefined;
  inStorage: number | undefined;
  installed: number | undefined;
  averageAge: number | undefined;
  utilization: number | undefined;
  ratio11000_110: number | undefined;
  ratio33000_110: number | undefined;
  constructor() {
    this.total = undefined;
    this.singlePhase = undefined;
    this.threePhase = undefined;
    this.inStorage = undefined;
    this.installed = undefined;
    this.averageAge = undefined;
    this.utilization = undefined;
    this.ratio11000_110 = undefined;
    this.ratio33000_110 = undefined;
  }
}
